import linegraph from '../../../../../components/linegraph.vue'
import * as echarts from "echarts"
import iTable from "../../../../../components/Table.vue";
import IPagination from "../../../../../components/pagination.vue";
import { domainName } from "../../../../../utility/index"

export default {
    data() {
        return {
            orgId: '',
            formInline: {
                driverNum: '',
                name: ''
            },
            height: '500',
            list: [], 
            option: {
                stripe: true,
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                mutiSelect: true, 
                serialNumber: true, 
            },
            columns: [],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1,
            pageSize: 10, 
            total: 1,
        }
    },
    components: {
        linegraph,
        iTable,
        IPagination
    },
    methods: {
        getMonthOrderList() {
            let param = {
                orgId: this.orgId,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                selectType: 0,
                driverNum: this.formInline.driverNum,
                name: this.formInline.name
            };
            this.$store.dispatch('DriverAnalysis/GET_QUERYDRIVERDAYWORKTIME', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        res.data.data.label.map(item => {
                            item.align = 'center'
                            item.width = '120'
                        })
                        this.columns = res.data.data.label
                        this.list = res.data.data.data.list
                        this.$refs.page.CommandTotal = res.data.data.data.total
                    }
                }
            }).catch(err => { })
        },
        onSearch() {
            this.getMonthOrderList()
        },
        onClear() {
            this.formInline.driverNum = ''
            this.formInline.name = ''
            this.getMonthOrderList()
        },
        downCar() {
            if (domainName) {
                if (domainName.split(':')[0] !== 'localhost') {
                    let url = `https://${domainName}/v1/getExportExcel/exportDriverDayWorkTime?orgId=${this.orgId}&selectType=${0}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}`
                    location.href = url
                } else {
                    let host = 'localhost:8080'
                    let url = `https://${host}/v1/getExportExcel/exportDriverDayWorkTime?orgId=${this.orgId}&selectType=${0}&driverNum=${this.formInline.driverNum}&name=${this.formInline.name}`
                    location.href = url
                }
            }
        },
        handleSelectionChange(val) {
            this.selected = val
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.getMonthOrderList()
        },
    }
}
